import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const PrivacyContext = createContext(null);

const PRIVACY_KEY = 'progetto_sabrina_privacy_mode';

export const PrivacyProvider = ({ children }) => {
  const [privacyMode, setPrivacyMode] = useState(() => {
    // Initialize from localStorage
    const saved = localStorage.getItem(PRIVACY_KEY);
    return saved === 'true';
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem(PRIVACY_KEY, privacyMode.toString());
  }, [privacyMode]);

  const togglePrivacyMode = useCallback(() => {
    setPrivacyMode(prev => !prev);
  }, []);

  const enablePrivacyMode = useCallback(() => {
    setPrivacyMode(true);
  }, []);

  const disablePrivacyMode = useCallback(() => {
    setPrivacyMode(false);
  }, []);

  return (
    <PrivacyContext.Provider value={{
      privacyMode,
      setPrivacyMode,
      togglePrivacyMode,
      enablePrivacyMode,
      disablePrivacyMode
    }}>
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => {
  const context = useContext(PrivacyContext);
  if (!context) {
    throw new Error('usePrivacy must be used within a PrivacyProvider');
  }
  return context;
};

export default PrivacyContext;
